/**
 * PDP Sticky Add to Cart
 * - Variant dropdowns sync bidirectionally with main product form
 * - View Cart updates in real time
 * - Price formatted directly from DOM (no Shopify.formatMoney dependency)
 * - Pushes up when cart notification is active
 */
(function () {
  const stickyBar   = document.getElementById('pdp-sticky-atc');
  if (!stickyBar) return;

  const stickyBtn     = stickyBar.querySelector('.pdp-sticky-atc__btn');
  const stickyInput   = stickyBar.querySelector('input[name="id"]');
  const viewCartBtn   = stickyBar.querySelector('.pdp-sticky-atc__view-cart');
  const stickySelects = Array.from(stickyBar.querySelectorAll('.pdp-sticky-atc__select'));
  const cartNotif     = document.getElementById('cart-notification');

  // ── 1. STICKY → MAIN FORM ─────────────────────────────────────
  // When user changes a sticky dropdown, trigger the matching
  // radio input in the main variant picker
  stickySelects.forEach((stickySelect) => {
    const optionIndex = parseInt(stickySelect.dataset.optionIndex);
    stickySelect.addEventListener('change', () => {
      const newValue = stickySelect.value;
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects) return;

      // Try radio/pill inputs first (our custom card picker)
      const allFieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
      const targetFieldset = allFieldsets[optionIndex];
      if (targetFieldset) {
        const radio = Array.from(targetFieldset.querySelectorAll('input[type="radio"]'))
          .find(r => r.value === newValue);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }

      // Fallback: select dropdown
      const selects = variantSelects.querySelectorAll('select');
      if (selects[optionIndex]) {
        selects[optionIndex].value = newValue;
        selects[optionIndex].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // ── 2. MAIN FORM → STICKY ─────────────────────────────────────
  // Strategy A: pubsub variantChange (fires after fetch completes)
  function setupPubSub() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(setupPubSub, 50);
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      if (!variant) return;
      syncStickyToVariant(variant);
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => updateViewCartBtn());
  }
  setupPubSub();

  // Strategy B: MutationObserver on product-info watching [data-selected-variant]
  // Acts as a reliable fallback when pubsub fires late or is missed
  const productInfoEl = document.querySelector('product-info');
  if (productInfoEl) {
    let _lastVariantId = null;
    new MutationObserver(() => {
      // Use rAF to let viewTransition settle before reading the updated element
      requestAnimationFrame(() => {
        const dataEl = productInfoEl.querySelector('[data-selected-variant]');
        if (!dataEl) return;
        try {
          const variant = JSON.parse(dataEl.textContent || dataEl.innerHTML);
          if (variant && variant.id !== _lastVariantId) {
            _lastVariantId = variant.id;
            syncStickyToVariant(variant);
          }
        } catch (e) {}
      });
    }).observe(productInfoEl, { childList: true, subtree: true, characterData: true });
  }

  // ── Sync sticky bar from variant object ───────────────────────
  function syncStickyToVariant(variant) {
    // Sync dropdown values
    if (variant.options && stickySelects.length) {
      stickySelects.forEach((sel, i) => {
        if (variant.options[i] !== undefined) sel.value = variant.options[i];
      });
    }

    // Update hidden variant ID
    if (stickyInput) {
      stickyInput.value    = variant.id;
      stickyInput.disabled = !variant.available;
    }

    // Update button text + state
    if (stickyBtn) {
      const textEl = stickyBtn.querySelector('span:first-child');
      if (textEl) {
        textEl.textContent = variant.available
          ? (window.variantStrings?.addToCart || 'Add to cart')
          : (window.variantStrings?.soldOut   || 'Sold out');
      }
      variant.available
        ? stickyBtn.removeAttribute('disabled')
        : stickyBtn.setAttribute('disabled', '');
    }

    // Update price — read formatted price from the main price element on the page
    // instead of relying on Shopify.formatMoney (not available in this Dawn build)
    const mainSalePrice = document.querySelector('.price__sale .price-item--sale, .price--large .price-item--sale');
    const formattedPrice = mainSalePrice?.textContent?.trim() || null;

    if (formattedPrice) {
      const btnPriceEl = stickyBar.querySelector('.pdp-sticky-atc__btn-price');
      if (btnPriceEl) btnPriceEl.textContent = formattedPrice;
    }
  }

  // ── View Cart button ──────────────────────────────────────────
  function updateViewCartBtn() {
    if (!viewCartBtn) return;
    fetch(`${window.routes?.cart_url ?? '/cart'}.js`)
      .then(r => r.json())
      .then(cart => {
        if (cart.item_count > 0) {
          viewCartBtn.classList.remove('hidden');
          viewCartBtn.textContent = `View cart (${cart.item_count})`;
        } else {
          viewCartBtn.classList.add('hidden');
        }
      })
      .catch(() => {});
  }

  updateViewCartBtn();
  document.addEventListener('cart:changed', updateViewCartBtn);

  // ── Push bar up when cart notification is active ──────────────
  function updateBottomOffset() {
    stickyBar.style.bottom = cartNotif?.classList.contains('active')
      ? cartNotif.offsetHeight + 'px'
      : '0px';
  }

  if (cartNotif) {
    new MutationObserver(updateBottomOffset).observe(cartNotif, {
      attributes: true, attributeFilter: ['class'],
    });
    updateBottomOffset();
  }
})();
